import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/AuthService';

/**
 * Factory: создаёт CanActivateFn, разрешающий доступ только при наличии
 * хотя бы одного из указанных permission'ов. super_admin проходит всегда.
 *
 * Использование в роутинге:
 *   { path: 'finances', canActivate: [permissionGuard('finance.view')] }
 *   { path: 'access',   canActivate: [permissionGuard(['users.view'])]  }
 *
 * При отказе редирект на /admin (а не /login) — пользователь авторизован,
 * просто нет прав на конкретный раздел.
 */
export const permissionGuard = (permission: string | string[]): CanActivateFn => {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    const required = Array.isArray(permission) ? permission : [permission];
    if (auth.hasAnyPermission(required)) return true;

    router.navigate(['/admin']);
    return false;
  };
};
